// extracted by mini-css-extract-plugin
export var container = "_nd-0";
export var dotAnimation = "_nd-2";
export var dotsLoading = "_nd-1";